// Generated on 2026-03-02T17:53:48.159Z
// This file contains preloaded top vehicle data from the API
// Do not edit manually - use 'npm run generate:top-vehicles-data' to regenerate

export const preloadedTopVehicles: any = [
  {
    "marca": "FORD",
    "modelo": "ESCAPE",
    "busquedas": "84639"
  },
  {
    "marca": "HONDA",
    "modelo": "CR-V",
    "busquedas": "84093"
  },
  {
    "marca": "TOYOTA",
    "modelo": "COROLLA",
    "busquedas": "76244"
  },
  {
    "marca": "HONDA",
    "modelo": "CIVIC",
    "busquedas": "63218"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "ELANTRA",
    "busquedas": "55519"
  },
  {
    "marca": "KIA",
    "modelo": "SORENTO",
    "busquedas": "26021"
  },
  {
    "marca": "TOYOTA",
    "modelo": "TACOMA",
    "busquedas": "23687"
  },
  {
    "marca": "NISSAN",
    "modelo": "FRONTIER",
    "busquedas": "20257"
  },
  {
    "marca": "FORD",
    "modelo": "EXPLORER",
    "busquedas": "19824"
  },
  {
    "marca": "TOYOTA",
    "modelo": "HILUX",
    "busquedas": "17208"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "L200",
    "busquedas": "16998"
  },
  {
    "marca": "TOYOTA",
    "modelo": "RAV4",
    "busquedas": "15544"
  },
  {
    "marca": "FORD",
    "modelo": "RANGER",
    "busquedas": "14524"
  },
  {
    "marca": "NISSAN",
    "modelo": "FRONTIER NP300 D23",
    "busquedas": "12258"
  },
  {
    "marca": "JEEP",
    "modelo": "PATRIOT",
    "busquedas": "11199"
  },
  {
    "marca": "ISUZU",
    "modelo": "D-MAX",
    "busquedas": "10114"
  },
  {
    "marca": "FORD",
    "modelo": "FOCUS",
    "busquedas": "9775"
  },
  {
    "marca": "TOYOTA",
    "modelo": "4RUNNER",
    "busquedas": "9424"
  },
  {
    "marca": "NISSAN",
    "modelo": "SENTRA",
    "busquedas": "9225"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "SANTA FE",
    "busquedas": "9054"
  },
  {
    "marca": "PONTIAC",
    "modelo": "VIBE",
    "busquedas": "8035"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "LANCER",
    "busquedas": "7752"
  },
  {
    "marca": "TOYOTA",
    "modelo": "PICKUP",
    "busquedas": "7591"
  },
  {
    "marca": "NISSAN",
    "modelo": "FRONTIER D22",
    "busquedas": "7435"
  },
  {
    "marca": "HONDA",
    "modelo": "FIT",
    "busquedas": "7101"
  },
  {
    "marca": "MAZDA",
    "modelo": "BT-50",
    "busquedas": "6978"
  },
  {
    "marca": "KIA",
    "modelo": "SPORTAGE",
    "busquedas": "6753"
  },
  {
    "marca": "FORD",
    "modelo": "F-150",
    "busquedas": "6380"
  },
  {
    "marca": "HONDA",
    "modelo": "PILOT",
    "busquedas": "6205"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "ACCENT",
    "busquedas": "6077"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "TUCSON",
    "busquedas": "5808"
  },
  {
    "marca": "HONDA",
    "modelo": "ACCORD",
    "busquedas": "5678"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "COLORADO",
    "busquedas": "5397"
  },
  {
    "marca": "NISSAN",
    "modelo": "ROGUE",
    "busquedas": "5337"
  },
  {
    "marca": "TOYOTA",
    "modelo": "LAND CRUISER PRADO",
    "busquedas": "4864"
  },
  {
    "marca": "NISSAN",
    "modelo": "PATHFINDER",
    "busquedas": "4332"
  },
  {
    "marca": "MAZDA",
    "modelo": "3",
    "busquedas": "4171"
  },
  {
    "marca": "TOYOTA",
    "modelo": "MATRIX",
    "busquedas": "4052"
  },
  {
    "marca": "JEEP",
    "modelo": "WRANGLER",
    "busquedas": "3963"
  },
  {
    "marca": "KIA",
    "modelo": "RIO",
    "busquedas": "3863"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SPARK",
    "busquedas": "3838"
  },
  {
    "marca": "TOYOTA",
    "modelo": "HIACE",
    "busquedas": "3558"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "OUTLANDER",
    "busquedas": "3471"
  },
  {
    "marca": "TOYOTA",
    "modelo": "YARIS",
    "busquedas": "3261"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "MONTERO SPORT",
    "busquedas": "3258"
  },
  {
    "marca": "TOYOTA",
    "modelo": "CAMRY",
    "busquedas": "2820"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "SANTA FE SPORT",
    "busquedas": "2623"
  },
  {
    "marca": "KIA",
    "modelo": "SPECTRA",
    "busquedas": "2549"
  },
  {
    "marca": "HONDA",
    "modelo": "ODYSSEY",
    "busquedas": "2483"
  },
  {
    "marca": "NISSAN",
    "modelo": "ALTIMA",
    "busquedas": "2439"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "AMAROK",
    "busquedas": "2434"
  },
  {
    "marca": "TOYOTA",
    "modelo": "TERCEL",
    "busquedas": "2429"
  },
  {
    "marca": "MAZDA",
    "modelo": "TRIBUTE",
    "busquedas": "2424"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CRUZE",
    "busquedas": "2355"
  },
  {
    "marca": "NISSAN",
    "modelo": "VERSA",
    "busquedas": "2325"
  },
  {
    "marca": "MAZDA",
    "modelo": "PROTEGE",
    "busquedas": "2300"
  },
  {
    "marca": "JEEP",
    "modelo": "COMPASS",
    "busquedas": "2255"
  },
  {
    "marca": "JEEP",
    "modelo": "CHEROKEE",
    "busquedas": "2192"
  },
  {
    "marca": "NISSAN",
    "modelo": "NAVARA D40",
    "busquedas": "2164"
  },
  {
    "marca": "JEEP",
    "modelo": "GRAND CHEROKEE",
    "busquedas": "2013"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "OUTLANDER SPORT",
    "busquedas": "1872"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "H-100",
    "busquedas": "1797"
  },
  {
    "marca": "TOYOTA",
    "modelo": "TUNDRA",
    "busquedas": "1707"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "TAHOE",
    "busquedas": "1699"
  },
  {
    "marca": "HONDA",
    "modelo": "HR-V",
    "busquedas": "1688"
  },
  {
    "marca": "FORD",
    "modelo": "EDGE",
    "busquedas": "1649"
  },
  {
    "marca": "BMW",
    "modelo": "X3",
    "busquedas": "1649"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "MIRAGE",
    "busquedas": "1619"
  },
  {
    "marca": "KIA",
    "modelo": "SOUL",
    "busquedas": "1610"
  },
  {
    "marca": "ISUZU",
    "modelo": "RODEO",
    "busquedas": "1572"
  },
  {
    "marca": "MAZDA",
    "modelo": "6",
    "busquedas": "1530"
  },
  {
    "marca": "KIA",
    "modelo": "PICANTO",
    "busquedas": "1525"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "MONTERO",
    "busquedas": "1445"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "TRAX",
    "busquedas": "1443"
  },
  {
    "marca": "TOYOTA",
    "modelo": "SIENNA",
    "busquedas": "1437"
  },
  {
    "marca": "NISSAN",
    "modelo": "XTERRA",
    "busquedas": "1390"
  },
  {
    "marca": "TOYOTA",
    "modelo": "HIGHLANDER",
    "busquedas": "1355"
  },
  {
    "marca": "NISSAN",
    "modelo": "D21",
    "busquedas": "1323"
  },
  {
    "marca": "KIA",
    "modelo": "SEPHIA",
    "busquedas": "1300"
  },
  {
    "marca": "HONDA",
    "modelo": "ELEMENT",
    "busquedas": "1281"
  },
  {
    "marca": "MAZDA",
    "modelo": "B2900",
    "busquedas": "1273"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "AVEO",
    "busquedas": "1231"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "NATIVA",
    "busquedas": "1214"
  },
  {
    "marca": "NISSAN",
    "modelo": "QASHQAI",
    "busquedas": "1209"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "GALANT",
    "busquedas": "1200"
  },
  {
    "marca": "DODGE",
    "modelo": "NEON",
    "busquedas": "1178"
  },
  {
    "marca": "FORD",
    "modelo": "EXPEDITION",
    "busquedas": "1172"
  },
  {
    "marca": "MAZDA",
    "modelo": "B2500",
    "busquedas": "1166"
  },
  {
    "marca": "NISSAN",
    "modelo": "PICKUP",
    "busquedas": "1162"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "S10",
    "busquedas": "1137"
  },
  {
    "marca": "TOYOTA",
    "modelo": "LAND CRUISER",
    "busquedas": "1134"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO 1500",
    "busquedas": "1130"
  },
  {
    "marca": "BMW",
    "modelo": "X5",
    "busquedas": "1128"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "SONATA",
    "busquedas": "1114"
  },
  {
    "marca": "NISSAN",
    "modelo": "URVAN",
    "busquedas": "1039"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "EQUINOX",
    "busquedas": "1036"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "GRAND STAREX",
    "busquedas": "1024"
  },
  {
    "marca": "MINI",
    "modelo": "COOPER",
    "busquedas": "1015"
  },
  {
    "marca": "NISSAN",
    "modelo": "PATROL",
    "busquedas": "1004"
  },
  {
    "marca": "FORD",
    "modelo": "MUSTANG",
    "busquedas": "991"
  },
  {
    "marca": "ISUZU",
    "modelo": "PICKUP KB",
    "busquedas": "906"
  },
  {
    "marca": "NISSAN",
    "modelo": "X-TRAIL",
    "busquedas": "875"
  },
  {
    "marca": "SUZUKI",
    "modelo": "GRAND VITARA",
    "busquedas": "847"
  },
  {
    "marca": "BMW",
    "modelo": "328I",
    "busquedas": "843"
  },
  {
    "marca": "MAZDA",
    "modelo": "CX-7",
    "busquedas": "796"
  },
  {
    "marca": "FORD",
    "modelo": "F-250 SUPER DUTY",
    "busquedas": "749"
  },
  {
    "marca": "RAM",
    "modelo": "1500",
    "busquedas": "726"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "TRACKER",
    "busquedas": "720"
  },
  {
    "marca": "NISSAN",
    "modelo": "MURANO",
    "busquedas": "709"
  },
  {
    "marca": "HONDA",
    "modelo": "RIDGELINE",
    "busquedas": "674"
  },
  {
    "marca": "MERCURY",
    "modelo": "MARINER",
    "busquedas": "656"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "JETTA",
    "busquedas": "646"
  },
  {
    "marca": "FORD",
    "modelo": "EXPLORER SPORT TRAC",
    "busquedas": "635"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "EON",
    "busquedas": "635"
  },
  {
    "marca": "JEEP",
    "modelo": "LIBERTY",
    "busquedas": "634"
  },
  {
    "marca": "MAZDA",
    "modelo": "B2200",
    "busquedas": "621"
  },
  {
    "marca": "NISSAN",
    "modelo": "URVAN NV350",
    "busquedas": "597"
  },
  {
    "marca": "FORD",
    "modelo": "ESCORT",
    "busquedas": "595"
  },
  {
    "marca": "MAZDA",
    "modelo": "323",
    "busquedas": "589"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "I10",
    "busquedas": "583"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SONIC",
    "busquedas": "572"
  },
  {
    "marca": "MAZDA",
    "modelo": "626",
    "busquedas": "569"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "ECLIPSE",
    "busquedas": "567"
  },
  {
    "marca": "DODGE",
    "modelo": "DAKOTA",
    "busquedas": "560"
  },
  {
    "marca": "DODGE",
    "modelo": "RAM 2500",
    "busquedas": "553"
  },
  {
    "marca": "MAZDA",
    "modelo": "BT-50 PRO",
    "busquedas": "551"
  },
  {
    "marca": "NISSAN",
    "modelo": "NV200",
    "busquedas": "539"
  },
  {
    "marca": "TOYOTA",
    "modelo": "ECHO",
    "busquedas": "514"
  },
  {
    "marca": "NISSAN",
    "modelo": "TIIDA",
    "busquedas": "506"
  },
  {
    "marca": "FORD",
    "modelo": "FIESTA",
    "busquedas": "498"
  },
  {
    "marca": "GMC",
    "modelo": "CANYON",
    "busquedas": "482"
  },
  {
    "marca": "NISSAN",
    "modelo": "KICKS",
    "busquedas": "477"
  },
  {
    "marca": "DODGE",
    "modelo": "CARAVAN",
    "busquedas": "465"
  },
  {
    "marca": "MAZDA",
    "modelo": "CX-5",
    "busquedas": "464"
  },
  {
    "marca": "JEEP",
    "modelo": "RENEGADE",
    "busquedas": "463"
  },
  {
    "marca": "NISSAN",
    "modelo": "JUKE",
    "busquedas": "437"
  },
  {
    "marca": "SUZUKI",
    "modelo": "ESTEEM",
    "busquedas": "429"
  },
  {
    "marca": "DODGE",
    "modelo": "RAM 1500",
    "busquedas": "426"
  },
  {
    "marca": "SUBARU",
    "modelo": "FORESTER",
    "busquedas": "422"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "L300",
    "busquedas": "421"
  },
  {
    "marca": "MAZDA",
    "modelo": "2",
    "busquedas": "417"
  },
  {
    "marca": "SCION",
    "modelo": "XB",
    "busquedas": "405"
  },
  {
    "marca": "BMW",
    "modelo": "325I",
    "busquedas": "396"
  },
  {
    "marca": "SUZUKI",
    "modelo": "VITARA",
    "busquedas": "388"
  },
  {
    "marca": "ISUZU",
    "modelo": "PICKUP",
    "busquedas": "385"
  },
  {
    "marca": "SCION",
    "modelo": "XA",
    "busquedas": "380"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "TIBURON",
    "busquedas": "366"
  },
  {
    "marca": "FORD",
    "modelo": "TRANSIT CONNECT",
    "busquedas": "366"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "H-1",
    "busquedas": "357"
  },
  {
    "marca": "TOYOTA",
    "modelo": "CELICA",
    "busquedas": "355"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "GRAND I10",
    "busquedas": "351"
  },
  {
    "marca": "DODGE",
    "modelo": "GRAND CARAVAN",
    "busquedas": "339"
  },
  {
    "marca": "KIA",
    "modelo": "FORTE",
    "busquedas": "330"
  },
  {
    "marca": "NISSAN",
    "modelo": "TITAN",
    "busquedas": "329"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "PRIZM",
    "busquedas": "328"
  },
  {
    "marca": "BMW",
    "modelo": "Z4",
    "busquedas": "326"
  },
  {
    "marca": "RAM",
    "modelo": "2500",
    "busquedas": "320"
  },
  {
    "marca": "SCION",
    "modelo": "TC",
    "busquedas": "311"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "ENDEAVOR",
    "busquedas": "307"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "AVALANCHE",
    "busquedas": "301"
  },
  {
    "marca": "ACURA",
    "modelo": "RDX",
    "busquedas": "297"
  },
  {
    "marca": "FORD",
    "modelo": "FUSION",
    "busquedas": "289"
  },
  {
    "marca": "MAZDA",
    "modelo": "B2300",
    "busquedas": "288"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "TIGUAN",
    "busquedas": "282"
  },
  {
    "marca": "SCION",
    "modelo": "XD",
    "busquedas": "282"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CAPTIVA",
    "busquedas": "280"
  },
  {
    "marca": "TOYOTA",
    "modelo": "FORTUNER",
    "busquedas": "279"
  },
  {
    "marca": "KIA",
    "modelo": "OPTIMA",
    "busquedas": "277"
  },
  {
    "marca": "SUBARU",
    "modelo": "IMPREZA",
    "busquedas": "275"
  },
  {
    "marca": "NISSAN",
    "modelo": "350Z",
    "busquedas": "271"
  },
  {
    "marca": "SUZUKI",
    "modelo": "FORENZA",
    "busquedas": "269"
  },
  {
    "marca": "SUZUKI",
    "modelo": "AERIO",
    "busquedas": "261"
  },
  {
    "marca": "SUZUKI",
    "modelo": "SX4",
    "busquedas": "256"
  },
  {
    "marca": "NISSAN",
    "modelo": "720",
    "busquedas": "254"
  },
  {
    "marca": "FORD",
    "modelo": "ECOSPORT",
    "busquedas": "253"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CAMARO",
    "busquedas": "249"
  },
  {
    "marca": "SUZUKI",
    "modelo": "SWIFT",
    "busquedas": "244"
  },
  {
    "marca": "ACURA",
    "modelo": "RSX",
    "busquedas": "243"
  },
  {
    "marca": "NISSAN",
    "modelo": "NP300",
    "busquedas": "242"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "CRETA",
    "busquedas": "238"
  },
  {
    "marca": "ACURA",
    "modelo": "TSX",
    "busquedas": "233"
  },
  {
    "marca": "ISUZU",
    "modelo": "TROOPER",
    "busquedas": "230"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SUBURBAN",
    "busquedas": "226"
  },
  {
    "marca": "TOYOTA",
    "modelo": "SEQUOIA",
    "busquedas": "226"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "TERRACAN",
    "busquedas": "223"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CAVALIER",
    "busquedas": "223"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "VELOSTER",
    "busquedas": "216"
  },
  {
    "marca": "SUBARU",
    "modelo": "OUTBACK",
    "busquedas": "213"
  },
  {
    "marca": "MAZDA",
    "modelo": "CX-9",
    "busquedas": "212"
  },
  {
    "marca": "NISSAN",
    "modelo": "ARMADA",
    "busquedas": "211"
  },
  {
    "marca": "ACURA",
    "modelo": "TL",
    "busquedas": "208"
  },
  {
    "marca": "DODGE",
    "modelo": "CALIBER",
    "busquedas": "204"
  },
  {
    "marca": "MAZDA",
    "modelo": "B2000",
    "busquedas": "203"
  },
  {
    "marca": "SUZUKI",
    "modelo": "SIDEKICK",
    "busquedas": "200"
  },
  {
    "marca": "HUMMER",
    "modelo": "H3",
    "busquedas": "199"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "N300",
    "busquedas": "186"
  },
  {
    "marca": "MAZDA",
    "modelo": "5",
    "busquedas": "186"
  },
  {
    "marca": "TOYOTA",
    "modelo": "T100",
    "busquedas": "185"
  },
  {
    "marca": "NISSAN",
    "modelo": "MAXIMA",
    "busquedas": "182"
  },
  {
    "marca": "SUZUKI",
    "modelo": "APV",
    "busquedas": "179"
  },
  {
    "marca": "DODGE",
    "modelo": "JOURNEY",
    "busquedas": "179"
  },
  {
    "marca": "ACURA",
    "modelo": "MDX",
    "busquedas": "179"
  },
  {
    "marca": "SATURN",
    "modelo": "VUE",
    "busquedas": "177"
  },
  {
    "marca": "BMW",
    "modelo": "X1",
    "busquedas": "176"
  },
  {
    "marca": "SUZUKI",
    "modelo": "JIMNY",
    "busquedas": "175"
  },
  {
    "marca": "MAZDA",
    "modelo": "MPV",
    "busquedas": "172"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "MALIBU",
    "busquedas": "170"
  },
  {
    "marca": "FORD",
    "modelo": "F-350 SUPER DUTY",
    "busquedas": "167"
  },
  {
    "marca": "GMC",
    "modelo": "SIERRA 1500",
    "busquedas": "167"
  },
  {
    "marca": "SUBARU",
    "modelo": "LEGACY",
    "busquedas": "164"
  },
  {
    "marca": "DODGE",
    "modelo": "DART",
    "busquedas": "164"
  },
  {
    "marca": "MAZDA",
    "modelo": "PROTEGE5",
    "busquedas": "161"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CAPTIVA SPORT",
    "busquedas": "160"
  },
  {
    "marca": "BMW",
    "modelo": "528I",
    "busquedas": "159"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "METRO",
    "busquedas": "158"
  },
  {
    "marca": "DODGE",
    "modelo": "RAM 3500",
    "busquedas": "149"
  },
  {
    "marca": "TOYOTA",
    "modelo": "FJ CRUISER",
    "busquedas": "144"
  },
  {
    "marca": "SUZUKI",
    "modelo": "SAMURAI",
    "busquedas": "144"
  },
  {
    "marca": "GEO",
    "modelo": "PRIZM",
    "busquedas": "139"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "PT CRUISER",
    "busquedas": "138"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "TRAVERSE",
    "busquedas": "134"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SUBURBAN 1500",
    "busquedas": "133"
  },
  {
    "marca": "ISUZU",
    "modelo": "MU-X",
    "busquedas": "132"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "TOWN & COUNTRY",
    "busquedas": "126"
  },
  {
    "marca": "NISSAN",
    "modelo": "QUEST",
    "busquedas": "125"
  },
  {
    "marca": "AUDI",
    "modelo": "A4",
    "busquedas": "122"
  },
  {
    "marca": "LEXUS",
    "modelo": "RX300",
    "busquedas": "122"
  },
  {
    "marca": "ACURA",
    "modelo": "INTEGRA",
    "busquedas": "119"
  },
  {
    "marca": "GMC",
    "modelo": "ACADIA",
    "busquedas": "119"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "PASSAT",
    "busquedas": "118"
  },
  {
    "marca": "PORSCHE",
    "modelo": "CAYENNE",
    "busquedas": "118"
  },
  {
    "marca": "BMW",
    "modelo": "335I",
    "busquedas": "118"
  },
  {
    "marca": "AUDI",
    "modelo": "Q7",
    "busquedas": "118"
  },
  {
    "marca": "DODGE",
    "modelo": "DURANGO",
    "busquedas": "117"
  },
  {
    "marca": "VOLVO",
    "modelo": "S40",
    "busquedas": "117"
  },
  {
    "marca": "LEXUS",
    "modelo": "GX470",
    "busquedas": "115"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "BLAZER",
    "busquedas": "114"
  },
  {
    "marca": "MAZDA",
    "modelo": "B3000",
    "busquedas": "113"
  },
  {
    "marca": "NISSAN",
    "modelo": "ALMERA",
    "busquedas": "112"
  },
  {
    "marca": "FORD",
    "modelo": "F-250",
    "busquedas": "112"
  },
  {
    "marca": "JEEP",
    "modelo": "GLADIATOR",
    "busquedas": "112"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO 2500 HD",
    "busquedas": "111"
  },
  {
    "marca": "MINI",
    "modelo": "COOPER COUNTRYMAN",
    "busquedas": "108"
  },
  {
    "marca": "TOYOTA",
    "modelo": "LAND CRUISER PICKUP",
    "busquedas": "107"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "ELANTRA GT",
    "busquedas": "107"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "VERACRUZ",
    "busquedas": "106"
  },
  {
    "marca": "BMW",
    "modelo": "X6",
    "busquedas": "105"
  },
  {
    "marca": "VOLVO",
    "modelo": "S60",
    "busquedas": "103"
  },
  {
    "marca": "KIA",
    "modelo": "SEDONA",
    "busquedas": "99"
  },
  {
    "marca": "CADILLAC",
    "modelo": "ESCALADE",
    "busquedas": "99"
  },
  {
    "marca": "ACURA",
    "modelo": "ILX",
    "busquedas": "93"
  },
  {
    "marca": "ISUZU",
    "modelo": "I-290",
    "busquedas": "92"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "TRAILBLAZER",
    "busquedas": "91"
  },
  {
    "marca": "FORD",
    "modelo": "TAURUS",
    "busquedas": "91"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "COBALT",
    "busquedas": "90"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "MATRIX",
    "busquedas": "89"
  },
  {
    "marca": "SUZUKI",
    "modelo": "XL-7",
    "busquedas": "88"
  },
  {
    "marca": "HONDA",
    "modelo": "CITY",
    "busquedas": "87"
  },
  {
    "marca": "NISSAN",
    "modelo": "NV350 URVAN",
    "busquedas": "86"
  },
  {
    "marca": "BMW",
    "modelo": "328I XDRIVE",
    "busquedas": "81"
  },
  {
    "marca": "DODGE",
    "modelo": "NITRO",
    "busquedas": "80"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "STAREX",
    "busquedas": "79"
  },
  {
    "marca": "LEXUS",
    "modelo": "LX470",
    "busquedas": "79"
  },
  {
    "marca": "RAM",
    "modelo": "3500",
    "busquedas": "79"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "BEETLE",
    "busquedas": "79"
  },
  {
    "marca": "HONDA",
    "modelo": "PASSPORT",
    "busquedas": "78"
  },
  {
    "marca": "DODGE",
    "modelo": "AVENGER",
    "busquedas": "78"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "VENTURE",
    "busquedas": "77"
  },
  {
    "marca": "VOLVO",
    "modelo": "XC90",
    "busquedas": "76"
  },
  {
    "marca": "BMW",
    "modelo": "128I",
    "busquedas": "75"
  },
  {
    "marca": "GMC",
    "modelo": "TERRAIN",
    "busquedas": "74"
  },
  {
    "marca": "FORD",
    "modelo": "WINDSTAR",
    "busquedas": "72"
  },
  {
    "marca": "INFINITI",
    "modelo": "QX60",
    "busquedas": "71"
  },
  {
    "marca": "TOYOTA",
    "modelo": "PRIUS",
    "busquedas": "69"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "BEAT",
    "busquedas": "69"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "200",
    "busquedas": "68"
  },
  {
    "marca": "BMW",
    "modelo": "330I",
    "busquedas": "67"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "C250",
    "busquedas": "67"
  },
  {
    "marca": "BMW",
    "modelo": "535I",
    "busquedas": "67"
  },
  {
    "marca": "SUZUKI",
    "modelo": "EQUATOR",
    "busquedas": "66"
  },
  {
    "marca": "BMW",
    "modelo": "330CI",
    "busquedas": "65"
  },
  {
    "marca": "ISUZU",
    "modelo": "HOMBRE",
    "busquedas": "65"
  },
  {
    "marca": "NISSAN",
    "modelo": "ROGUE SPORT",
    "busquedas": "65"
  },
  {
    "marca": "KIA",
    "modelo": "CERATO",
    "busquedas": "64"
  },
  {
    "marca": "GMC",
    "modelo": "SONOMA",
    "busquedas": "64"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "OPTRA",
    "busquedas": "64"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "TOUAREG",
    "busquedas": "63"
  },
  {
    "marca": "GEO",
    "modelo": "METRO",
    "busquedas": "63"
  },
  {
    "marca": "MAZDA",
    "modelo": "B2600",
    "busquedas": "61"
  },
  {
    "marca": "HONDA",
    "modelo": "CROSSTOUR",
    "busquedas": "60"
  },
  {
    "marca": "BMW",
    "modelo": "320I",
    "busquedas": "59"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "MIGHTY MAX",
    "busquedas": "59"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "MIRAGE G4",
    "busquedas": "59"
  },
  {
    "marca": "SUBARU",
    "modelo": "BAJA",
    "busquedas": "57"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "N400",
    "busquedas": "56"
  },
  {
    "marca": "FIAT",
    "modelo": "500",
    "busquedas": "56"
  },
  {
    "marca": "KIA",
    "modelo": "PREGIO",
    "busquedas": "56"
  },
  {
    "marca": "LINCOLN",
    "modelo": "NAVIGATOR",
    "busquedas": "55"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "C230",
    "busquedas": "55"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "ATOS",
    "busquedas": "55"
  },
  {
    "marca": "BMW",
    "modelo": "525I",
    "busquedas": "55"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "RAIDER",
    "busquedas": "54"
  },
  {
    "marca": "BMW",
    "modelo": "325CI",
    "busquedas": "53"
  },
  {
    "marca": "LEXUS",
    "modelo": "GX460",
    "busquedas": "53"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "ASX",
    "busquedas": "52"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "AVALANCHE 1500",
    "busquedas": "52"
  },
  {
    "marca": "FORD",
    "modelo": "E-350 SUPER DUTY",
    "busquedas": "52"
  },
  {
    "marca": "KIA",
    "modelo": "SPECTRA5",
    "busquedas": "52"
  },
  {
    "marca": "NISSAN",
    "modelo": "VERSA NOTE",
    "busquedas": "50"
  },
  {
    "marca": "TOYOTA",
    "modelo": "AVALON",
    "busquedas": "50"
  },
  {
    "marca": "INFINITI",
    "modelo": "FX35",
    "busquedas": "50"
  },
  {
    "marca": "ISUZU",
    "modelo": "RODEO SPORT",
    "busquedas": "50"
  },
  {
    "marca": "TOYOTA",
    "modelo": "AVENSIS",
    "busquedas": "50"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "GOLF",
    "busquedas": "49"
  },
  {
    "marca": "BMW",
    "modelo": "323I",
    "busquedas": "49"
  },
  {
    "marca": "SUZUKI",
    "modelo": "RENO",
    "busquedas": "48"
  },
  {
    "marca": "AUDI",
    "modelo": "Q5",
    "busquedas": "48"
  },
  {
    "marca": "ISUZU",
    "modelo": "I-280",
    "busquedas": "47"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "SEBRING",
    "busquedas": "46"
  },
  {
    "marca": "DODGE",
    "modelo": "CHALLENGER",
    "busquedas": "45"
  },
  {
    "marca": "TOYOTA",
    "modelo": "CRESSIDA",
    "busquedas": "45"
  },
  {
    "marca": "BMW",
    "modelo": "325XI",
    "busquedas": "44"
  },
  {
    "marca": "LINCOLN",
    "modelo": "MKX",
    "busquedas": "44"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "ELANTRA COUPE",
    "busquedas": "43"
  },
  {
    "marca": "SUZUKI",
    "modelo": "CELERIO",
    "busquedas": "43"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "VENUE",
    "busquedas": "43"
  },
  {
    "marca": "INFINITI",
    "modelo": "QX4",
    "busquedas": "43"
  },
  {
    "marca": "GMC",
    "modelo": "YUKON",
    "busquedas": "43"
  },
  {
    "marca": "AUDI",
    "modelo": "TT",
    "busquedas": "42"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "E320",
    "busquedas": "42"
  },
  {
    "marca": "DODGE",
    "modelo": "CHARGER",
    "busquedas": "42"
  },
  {
    "marca": "ISUZU",
    "modelo": "AMIGO",
    "busquedas": "41"
  },
  {
    "marca": "KIA",
    "modelo": "SELTOS",
    "busquedas": "41"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "300",
    "busquedas": "40"
  },
  {
    "marca": "DAIHATSU",
    "modelo": "TERIOS",
    "busquedas": "40"
  },
  {
    "marca": "PONTIAC",
    "modelo": "SOLSTICE",
    "busquedas": "40"
  },
  {
    "marca": "HUMMER",
    "modelo": "H2",
    "busquedas": "40"
  },
  {
    "marca": "GMC",
    "modelo": "ENVOY",
    "busquedas": "39"
  },
  {
    "marca": "NISSAN",
    "modelo": "NP300 FRONTIER",
    "busquedas": "39"
  },
  {
    "marca": "KIA",
    "modelo": "RONDO",
    "busquedas": "39"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "DISCOVERY",
    "busquedas": "38"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "GRACE",
    "busquedas": "37"
  },
  {
    "marca": "PONTIAC",
    "modelo": "SUNFIRE",
    "busquedas": "37"
  },
  {
    "marca": "LEXUS",
    "modelo": "RX330",
    "busquedas": "36"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "ML350",
    "busquedas": "36"
  },
  {
    "marca": "GMC",
    "modelo": "SIERRA 2500 HD",
    "busquedas": "36"
  },
  {
    "marca": "NISSAN",
    "modelo": "CUBE",
    "busquedas": "36"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "GENESIS COUPE",
    "busquedas": "36"
  },
  {
    "marca": "VOLVO",
    "modelo": "S80",
    "busquedas": "35"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO 2500",
    "busquedas": "35"
  },
  {
    "marca": "LEXUS",
    "modelo": "IS250",
    "busquedas": "35"
  },
  {
    "marca": "LEXUS",
    "modelo": "IS300",
    "busquedas": "34"
  },
  {
    "marca": "VOLVO",
    "modelo": "XC70",
    "busquedas": "34"
  },
  {
    "marca": "TOYOTA",
    "modelo": "URBAN CRUISER",
    "busquedas": "34"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "GROOVE",
    "busquedas": "34"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "IMPALA",
    "busquedas": "34"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "RANGE ROVER",
    "busquedas": "34"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "C300",
    "busquedas": "33"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "HHR",
    "busquedas": "33"
  },
  {
    "marca": "LINCOLN",
    "modelo": "AVIATOR",
    "busquedas": "33"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "PACIFICA",
    "busquedas": "33"
  },
  {
    "marca": "TOYOTA",
    "modelo": "SUPRA",
    "busquedas": "33"
  },
  {
    "marca": "MAZDA",
    "modelo": "CX-3",
    "busquedas": "32"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "EXCEL",
    "busquedas": "32"
  },
  {
    "marca": "BMW",
    "modelo": "Z3",
    "busquedas": "32"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "R350",
    "busquedas": "32"
  },
  {
    "marca": "SCION",
    "modelo": "IQ",
    "busquedas": "31"
  },
  {
    "marca": "FORD",
    "modelo": "EXCURSION",
    "busquedas": "31"
  },
  {
    "marca": "MAZDA",
    "modelo": "MIATA",
    "busquedas": "31"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "ENTOURAGE",
    "busquedas": "30"
  },
  {
    "marca": "BMW",
    "modelo": "318I",
    "busquedas": "30"
  },
  {
    "marca": "INFINITI",
    "modelo": "G35",
    "busquedas": "30"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "TAOS",
    "busquedas": "30"
  },
  {
    "marca": "MERCURY",
    "modelo": "TRACER",
    "busquedas": "30"
  },
  {
    "marca": "FORD",
    "modelo": "E-150",
    "busquedas": "30"
  },
  {
    "marca": "HONDA",
    "modelo": "INSIGHT",
    "busquedas": "30"
  },
  {
    "marca": "BMW",
    "modelo": "530I",
    "busquedas": "30"
  },
  {
    "marca": "FORD",
    "modelo": "FLEX",
    "busquedas": "30"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CRUZE LIMITED",
    "busquedas": "30"
  },
  {
    "marca": "JEEP",
    "modelo": "COMMANDER",
    "busquedas": "30"
  },
  {
    "marca": "BMW",
    "modelo": "330XI",
    "busquedas": "29"
  },
  {
    "marca": "PONTIAC",
    "modelo": "TORRENT",
    "busquedas": "28"
  },
  {
    "marca": "TOYOTA",
    "modelo": "STARLET",
    "busquedas": "28"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "EXPRESS 1500",
    "busquedas": "28"
  },
  {
    "marca": "FORD",
    "modelo": "BRONCO",
    "busquedas": "28"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "GTI",
    "busquedas": "28"
  },
  {
    "marca": "NISSAN",
    "modelo": "240SX",
    "busquedas": "28"
  },
  {
    "marca": "JAGUAR",
    "modelo": "X-TYPE",
    "busquedas": "28"
  },
  {
    "marca": "MAZDA",
    "modelo": "B4000",
    "busquedas": "27"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "CC",
    "busquedas": "27"
  },
  {
    "marca": "KIA",
    "modelo": "SOLUTO",
    "busquedas": "27"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "ML320",
    "busquedas": "27"
  },
  {
    "marca": "SATURN",
    "modelo": "SL2",
    "busquedas": "26"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GL450",
    "busquedas": "26"
  },
  {
    "marca": "VOLVO",
    "modelo": "XC60",
    "busquedas": "25"
  },
  {
    "marca": "FORD",
    "modelo": "BRONCO SPORT",
    "busquedas": "24"
  },
  {
    "marca": "LEXUS",
    "modelo": "ES330",
    "busquedas": "24"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "FREELANDER",
    "busquedas": "24"
  },
  {
    "marca": "FORD",
    "modelo": "TRANSIT-150",
    "busquedas": "24"
  },
  {
    "marca": "AUDI",
    "modelo": "S4",
    "busquedas": "24"
  },
  {
    "marca": "SATURN",
    "modelo": "SL1",
    "busquedas": "23"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "RANGE ROVER SPORT",
    "busquedas": "23"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "PALISADE",
    "busquedas": "23"
  },
  {
    "marca": "LEXUS",
    "modelo": "RX350",
    "busquedas": "23"
  },
  {
    "marca": "PLYMOUTH",
    "modelo": "VOYAGER",
    "busquedas": "23"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "GETZ",
    "busquedas": "22"
  },
  {
    "marca": "TOYOTA",
    "modelo": "LAND CRUISER II",
    "busquedas": "22"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "POLO",
    "busquedas": "22"
  },
  {
    "marca": "SATURN",
    "modelo": "ION",
    "busquedas": "21"
  },
  {
    "marca": "PONTIAC",
    "modelo": "G6",
    "busquedas": "21"
  },
  {
    "marca": "INFINITI",
    "modelo": "QX80",
    "busquedas": "20"
  },
  {
    "marca": "TOYOTA",
    "modelo": "COASTER",
    "busquedas": "20"
  },
  {
    "marca": "ACURA",
    "modelo": "TLX",
    "busquedas": "20"
  },
  {
    "marca": "TOYOTA",
    "modelo": "VENZA",
    "busquedas": "20"
  },
  {
    "marca": "TOYOTA",
    "modelo": "RUSH",
    "busquedas": "20"
  },
  {
    "marca": "RENAULT",
    "modelo": "KOLEOS",
    "busquedas": "19"
  },
  {
    "marca": "KIA",
    "modelo": "RIO5",
    "busquedas": "19"
  },
  {
    "marca": "KIA",
    "modelo": "SONET",
    "busquedas": "19"
  },
  {
    "marca": "FORD",
    "modelo": "E-250",
    "busquedas": "19"
  },
  {
    "marca": "CADILLAC",
    "modelo": "SRX",
    "busquedas": "19"
  },
  {
    "marca": "TOYOTA",
    "modelo": "SOLARA",
    "busquedas": "19"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SUBURBAN 2500",
    "busquedas": "19"
  },
  {
    "marca": "DAIHATSU",
    "modelo": "SIRION",
    "busquedas": "19"
  },
  {
    "marca": "FORD",
    "modelo": "FREESTYLE",
    "busquedas": "19"
  },
  {
    "marca": "BMW",
    "modelo": "328XI",
    "busquedas": "19"
  },
  {
    "marca": "SATURN",
    "modelo": "SL",
    "busquedas": "19"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO 3500",
    "busquedas": "18"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CITY EXPRESS",
    "busquedas": "18"
  },
  {
    "marca": "TOYOTA",
    "modelo": "VAN",
    "busquedas": "18"
  },
  {
    "marca": "PLYMOUTH",
    "modelo": "NEON",
    "busquedas": "18"
  },
  {
    "marca": "HONDA",
    "modelo": "CR-Z",
    "busquedas": "18"
  },
  {
    "marca": "INFINITI",
    "modelo": "QX56",
    "busquedas": "18"
  },
  {
    "marca": "BMW",
    "modelo": "X4",
    "busquedas": "18"
  },
  {
    "marca": "ISUZU",
    "modelo": "I-MARK",
    "busquedas": "18"
  },
  {
    "marca": "FORD",
    "modelo": "CONTOUR",
    "busquedas": "18"
  },
  {
    "marca": "MERCURY",
    "modelo": "MOUNTAINEER",
    "busquedas": "17"
  },
  {
    "marca": "LEXUS",
    "modelo": "ES300",
    "busquedas": "17"
  },
  {
    "marca": "TOYOTA",
    "modelo": "PREVIA",
    "busquedas": "16"
  },
  {
    "marca": "FORD",
    "modelo": "FREESTAR",
    "busquedas": "16"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "MONTERO IO",
    "busquedas": "16"
  },
  {
    "marca": "BUICK",
    "modelo": "ENCORE",
    "busquedas": "16"
  },
  {
    "marca": "SUBARU",
    "modelo": "XV CROSSTREK",
    "busquedas": "16"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GLK350",
    "busquedas": "16"
  },
  {
    "marca": "FORD",
    "modelo": "FIGO",
    "busquedas": "16"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "I20",
    "busquedas": "16"
  },
  {
    "marca": "TOYOTA",
    "modelo": "YARIS IA",
    "busquedas": "16"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "ECLIPSE CROSS",
    "busquedas": "15"
  },
  {
    "marca": "DODGE",
    "modelo": "STRATUS",
    "busquedas": "15"
  },
  {
    "marca": "PORSCHE",
    "modelo": "BOXSTER",
    "busquedas": "15"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO",
    "busquedas": "15"
  },
  {
    "marca": "KIA",
    "modelo": "CARENS",
    "busquedas": "15"
  },
  {
    "marca": "FORD",
    "modelo": "TRANSIT-350",
    "busquedas": "15"
  },
  {
    "marca": "FORD",
    "modelo": "EXPLORER SPORT",
    "busquedas": "15"
  },
  {
    "marca": "SUZUKI",
    "modelo": "S-PRESSO",
    "busquedas": "15"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CORVETTE",
    "busquedas": "15"
  },
  {
    "marca": "GMC",
    "modelo": "SAFARI",
    "busquedas": "14"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "ATLAS",
    "busquedas": "14"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "C240",
    "busquedas": "14"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CMV",
    "busquedas": "14"
  },
  {
    "marca": "PONTIAC",
    "modelo": "GRAND PRIX",
    "busquedas": "14"
  },
  {
    "marca": "INFINITI",
    "modelo": "JX35",
    "busquedas": "14"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO 3500 HD",
    "busquedas": "14"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "ASTRO",
    "busquedas": "14"
  },
  {
    "marca": "SUZUKI",
    "modelo": "IGNIS",
    "busquedas": "14"
  },
  {
    "marca": "CADILLAC",
    "modelo": "ESCALADE ESV",
    "busquedas": "13"
  },
  {
    "marca": "KIA",
    "modelo": "BORREGO",
    "busquedas": "13"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "E350",
    "busquedas": "13"
  },
  {
    "marca": "BUICK",
    "modelo": "ENCLAVE",
    "busquedas": "13"
  },
  {
    "marca": "CADILLAC",
    "modelo": "CTS",
    "busquedas": "13"
  },
  {
    "marca": "TOYOTA",
    "modelo": "COROLLA IM",
    "busquedas": "13"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "SAVEIRO",
    "busquedas": "13"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "CROSSFOX",
    "busquedas": "13"
  },
  {
    "marca": "DODGE",
    "modelo": "D350",
    "busquedas": "13"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "SLK300",
    "busquedas": "13"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "C1500",
    "busquedas": "13"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "EXPRESS 2500",
    "busquedas": "12"
  },
  {
    "marca": "FORD",
    "modelo": "FESTIVA",
    "busquedas": "12"
  },
  {
    "marca": "BMW",
    "modelo": "740I",
    "busquedas": "12"
  },
  {
    "marca": "GMC",
    "modelo": "SAVANA 2500",
    "busquedas": "12"
  },
  {
    "marca": "GEO",
    "modelo": "TRACKER",
    "busquedas": "12"
  },
  {
    "marca": "FORD",
    "modelo": "BRONCO II",
    "busquedas": "12"
  },
  {
    "marca": "VOLVO",
    "modelo": "C70",
    "busquedas": "12"
  },
  {
    "marca": "NISSAN",
    "modelo": "PATHFINDER ARMADA",
    "busquedas": "12"
  },
  {
    "marca": "BMW",
    "modelo": "640I",
    "busquedas": "12"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "S10 BLAZER",
    "busquedas": "11"
  },
  {
    "marca": "KIA",
    "modelo": "CARNIVAL",
    "busquedas": "11"
  },
  {
    "marca": "MAZDA",
    "modelo": "CX-30",
    "busquedas": "11"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "C350",
    "busquedas": "11"
  },
  {
    "marca": "MINI",
    "modelo": "COOPER PACEMAN",
    "busquedas": "11"
  },
  {
    "marca": "FORD",
    "modelo": "E-350 ECONOLINE",
    "busquedas": "11"
  },
  {
    "marca": "DAEWOO",
    "modelo": "LANOS",
    "busquedas": "11"
  },
  {
    "marca": "SUBARU",
    "modelo": "CROSSTREK",
    "busquedas": "11"
  },
  {
    "marca": "FORD",
    "modelo": "TRANSIT-250",
    "busquedas": "11"
  },
  {
    "marca": "NISSAN",
    "modelo": "ROGUE SELECT",
    "busquedas": "11"
  },
  {
    "marca": "PLYMOUTH",
    "modelo": "BREEZE",
    "busquedas": "11"
  },
  {
    "marca": "LEXUS",
    "modelo": "LX450",
    "busquedas": "11"
  },
  {
    "marca": "JMC",
    "modelo": "VIGUS",
    "busquedas": "11"
  },
  {
    "marca": "RENAULT",
    "modelo": "CLIO",
    "busquedas": "10"
  },
  {
    "marca": "DODGE",
    "modelo": "RAIDER",
    "busquedas": "10"
  },
  {
    "marca": "MAHINDRA",
    "modelo": "SCORPIO",
    "busquedas": "10"
  },
  {
    "marca": "CADILLAC",
    "modelo": "XT5",
    "busquedas": "10"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "SLK350",
    "busquedas": "10"
  },
  {
    "marca": "KIA",
    "modelo": "FORTE KOUP",
    "busquedas": "10"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "SLK250",
    "busquedas": "10"
  },
  {
    "marca": "MAZDA",
    "modelo": "RX-8",
    "busquedas": "10"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "C320",
    "busquedas": "10"
  },
  {
    "marca": "BMW",
    "modelo": "318IS",
    "busquedas": "10"
  },
  {
    "marca": "TOYOTA",
    "modelo": "CORONA",
    "busquedas": "10"
  },
  {
    "marca": "GMC",
    "modelo": "JIMMY",
    "busquedas": "9"
  },
  {
    "marca": "BMW",
    "modelo": "325ES",
    "busquedas": "9"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "K1500",
    "busquedas": "9"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "LR2",
    "busquedas": "9"
  },
  {
    "marca": "NISSAN",
    "modelo": "MARCH",
    "busquedas": "9"
  },
  {
    "marca": "FOTON",
    "modelo": "TUNLAND",
    "busquedas": "9"
  },
  {
    "marca": "PORSCHE",
    "modelo": "MACAN",
    "busquedas": "9"
  },
  {
    "marca": "MAZDA",
    "modelo": "MX-5 MIATA",
    "busquedas": "9"
  },
  {
    "marca": "SUBARU",
    "modelo": "BRAT",
    "busquedas": "9"
  },
  {
    "marca": "SUBARU",
    "modelo": "BRZ",
    "busquedas": "9"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "C280",
    "busquedas": "9"
  },
  {
    "marca": "SUZUKI",
    "modelo": "ERTIGA",
    "busquedas": "9"
  },
  {
    "marca": "AUDI",
    "modelo": "A3",
    "busquedas": "9"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "C1500 SUBURBAN",
    "busquedas": "9"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "VOYAGER",
    "busquedas": "9"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO 1500 LTD",
    "busquedas": "8"
  },
  {
    "marca": "BMW",
    "modelo": "325E",
    "busquedas": "8"
  },
  {
    "marca": "FORD",
    "modelo": "E-350 ECONOLINE CLUB WAGON",
    "busquedas": "8"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "SLK230",
    "busquedas": "8"
  },
  {
    "marca": "BMW",
    "modelo": "528I XDRIVE",
    "busquedas": "8"
  },
  {
    "marca": "BUICK",
    "modelo": "RENDEZVOUS",
    "busquedas": "8"
  },
  {
    "marca": "LEXUS",
    "modelo": "GS300",
    "busquedas": "8"
  },
  {
    "marca": "BUICK",
    "modelo": "LACROSSE",
    "busquedas": "8"
  },
  {
    "marca": "LEXUS",
    "modelo": "LX570",
    "busquedas": "8"
  },
  {
    "marca": "INFINITI",
    "modelo": "G20",
    "busquedas": "8"
  },
  {
    "marca": "TOYOTA",
    "modelo": "PRIUS V",
    "busquedas": "8"
  },
  {
    "marca": "HONDA",
    "modelo": "PRELUDE",
    "busquedas": "8"
  },
  {
    "marca": "SCION",
    "modelo": "FR-S",
    "busquedas": "8"
  },
  {
    "marca": "GMC",
    "modelo": "SIERRA",
    "busquedas": "8"
  },
  {
    "marca": "PORSCHE",
    "modelo": "PANAMERA",
    "busquedas": "8"
  },
  {
    "marca": "BMW",
    "modelo": "650I",
    "busquedas": "7"
  },
  {
    "marca": "NISSAN",
    "modelo": "TITAN XD",
    "busquedas": "7"
  },
  {
    "marca": "RAM",
    "modelo": "700",
    "busquedas": "7"
  },
  {
    "marca": "FORD",
    "modelo": "F-350",
    "busquedas": "7"
  },
  {
    "marca": "GMC",
    "modelo": "S15",
    "busquedas": "7"
  },
  {
    "marca": "LEXUS",
    "modelo": "LS400",
    "busquedas": "7"
  },
  {
    "marca": "GMC",
    "modelo": "SIERRA 2500",
    "busquedas": "7"
  },
  {
    "marca": "VOLVO",
    "modelo": "S70",
    "busquedas": "7"
  },
  {
    "marca": "DAEWOO",
    "modelo": "NUBIRA",
    "busquedas": "7"
  },
  {
    "marca": "FORD",
    "modelo": "E-150 ECONOLINE",
    "busquedas": "7"
  },
  {
    "marca": "DAEWOO",
    "modelo": "LEGANZA",
    "busquedas": "7"
  },
  {
    "marca": "TOYOTA",
    "modelo": "LITE ACE",
    "busquedas": "7"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GLA250",
    "busquedas": "7"
  },
  {
    "marca": "HONDA",
    "modelo": "S2000",
    "busquedas": "7"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "3000GT",
    "busquedas": "7"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "OUTLANDER PHEV",
    "busquedas": "7"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "FOX",
    "busquedas": "6"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "300D",
    "busquedas": "6"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SPARK CLASSIC",
    "busquedas": "6"
  },
  {
    "marca": "RAM",
    "modelo": "1500 CLASSIC",
    "busquedas": "6"
  },
  {
    "marca": "MASERATI",
    "modelo": "QUATTROPORTE",
    "busquedas": "6"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO 1500 LD",
    "busquedas": "6"
  },
  {
    "marca": "PONTIAC",
    "modelo": "G5",
    "busquedas": "6"
  },
  {
    "marca": "INFINITI",
    "modelo": "EX35",
    "busquedas": "6"
  },
  {
    "marca": "PLYMOUTH",
    "modelo": "GRAND VOYAGER",
    "busquedas": "6"
  },
  {
    "marca": "TOYOTA",
    "modelo": "MR2",
    "busquedas": "6"
  },
  {
    "marca": "AUDI",
    "modelo": "A4 QUATTRO",
    "busquedas": "6"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "CLK430",
    "busquedas": "6"
  },
  {
    "marca": "TOYOTA",
    "modelo": "RAIZE",
    "busquedas": "6"
  },
  {
    "marca": "DODGE",
    "modelo": "RAM 3500 VAN",
    "busquedas": "6"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "C3500",
    "busquedas": "6"
  },
  {
    "marca": "NISSAN",
    "modelo": "STANZA",
    "busquedas": "6"
  },
  {
    "marca": "LEXUS",
    "modelo": "GS350",
    "busquedas": "6"
  },
  {
    "marca": "NISSAN",
    "modelo": "QASHQAI+2",
    "busquedas": "6"
  },
  {
    "marca": "KIA",
    "modelo": "TELLURIDE",
    "busquedas": "6"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "RABBIT",
    "busquedas": "6"
  },
  {
    "marca": "MERCURY",
    "modelo": "COUGAR",
    "busquedas": "6"
  },
  {
    "marca": "NISSAN",
    "modelo": "200SX",
    "busquedas": "5"
  },
  {
    "marca": "ACURA",
    "modelo": "RL",
    "busquedas": "5"
  },
  {
    "marca": "RENAULT",
    "modelo": "KANGOO",
    "busquedas": "5"
  },
  {
    "marca": "JAC",
    "modelo": "X200",
    "busquedas": "5"
  },
  {
    "marca": "FORD",
    "modelo": "TAURUS X",
    "busquedas": "5"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "LR3",
    "busquedas": "5"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GL320",
    "busquedas": "5"
  },
  {
    "marca": "JIM",
    "modelo": "REMAX",
    "busquedas": "5"
  },
  {
    "marca": "SATURN",
    "modelo": "LS1",
    "busquedas": "5"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "DIAMANTE",
    "busquedas": "5"
  },
  {
    "marca": "DODGE",
    "modelo": "ATTITUDE",
    "busquedas": "5"
  },
  {
    "marca": "SUBARU",
    "modelo": "TRIBECA",
    "busquedas": "5"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "CABRIO",
    "busquedas": "5"
  },
  {
    "marca": "BMW",
    "modelo": "328D XDRIVE",
    "busquedas": "5"
  },
  {
    "marca": "PONTIAC",
    "modelo": "G3",
    "busquedas": "5"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "EXPO",
    "busquedas": "5"
  },
  {
    "marca": "BMW",
    "modelo": "428I",
    "busquedas": "5"
  },
  {
    "marca": "BMW",
    "modelo": "335XI",
    "busquedas": "5"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "CLK500",
    "busquedas": "5"
  },
  {
    "marca": "LEXUS",
    "modelo": "NX300",
    "busquedas": "5"
  },
  {
    "marca": "JAGUAR",
    "modelo": "S-TYPE",
    "busquedas": "5"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GLS450",
    "busquedas": "5"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "EXPRESS 3500",
    "busquedas": "5"
  },
  {
    "marca": "TOYOTA",
    "modelo": "GR86",
    "busquedas": "5"
  },
  {
    "marca": "BMW",
    "modelo": "X7",
    "busquedas": "4"
  },
  {
    "marca": "FORD",
    "modelo": "TRANSIT",
    "busquedas": "4"
  },
  {
    "marca": "BMW",
    "modelo": "320I XDRIVE",
    "busquedas": "4"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "BORA",
    "busquedas": "4"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "GENESIS",
    "busquedas": "4"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "UPLANDER",
    "busquedas": "4"
  },
  {
    "marca": "SCION",
    "modelo": "IM",
    "busquedas": "4"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "CLA250",
    "busquedas": "4"
  },
  {
    "marca": "BMW",
    "modelo": "328CI",
    "busquedas": "4"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "LR4",
    "busquedas": "4"
  },
  {
    "marca": "ISUZU",
    "modelo": "AXIOM",
    "busquedas": "4"
  },
  {
    "marca": "NISSAN",
    "modelo": "370Z",
    "busquedas": "4"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "DISCOVERY SPORT",
    "busquedas": "4"
  },
  {
    "marca": "FIAT",
    "modelo": "SIENA",
    "busquedas": "4"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "DEFENDER",
    "busquedas": "4"
  },
  {
    "marca": "TOYOTA",
    "modelo": "COROLLA CROSS",
    "busquedas": "4"
  },
  {
    "marca": "RAM",
    "modelo": "PROMASTER 3500",
    "busquedas": "4"
  },
  {
    "marca": "FORD",
    "modelo": "MAVERICK",
    "busquedas": "4"
  },
  {
    "marca": "LINCOLN",
    "modelo": "MKZ",
    "busquedas": "4"
  },
  {
    "marca": "LINCOLN",
    "modelo": "MKS",
    "busquedas": "4"
  },
  {
    "marca": "BMW",
    "modelo": "335D",
    "busquedas": "4"
  },
  {
    "marca": "JAC",
    "modelo": "T6",
    "busquedas": "4"
  },
  {
    "marca": "DODGE",
    "modelo": "B1500",
    "busquedas": "4"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CMP",
    "busquedas": "4"
  },
  {
    "marca": "TOYOTA",
    "modelo": "MR2 SPYDER",
    "busquedas": "4"
  },
  {
    "marca": "TOYOTA",
    "modelo": "PASEO",
    "busquedas": "4"
  },
  {
    "marca": "GMC",
    "modelo": "ENVOY XL",
    "busquedas": "4"
  },
  {
    "marca": "BMW",
    "modelo": "325",
    "busquedas": "4"
  },
  {
    "marca": "MAZDA",
    "modelo": "CX-50",
    "busquedas": "4"
  },
  {
    "marca": "SUBARU",
    "modelo": "GL",
    "busquedas": "4"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "S320",
    "busquedas": "4"
  },
  {
    "marca": "KIA",
    "modelo": "FORTE5",
    "busquedas": "4"
  },
  {
    "marca": "LEXUS",
    "modelo": "RX400H",
    "busquedas": "4"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "T-CROSS",
    "busquedas": "4"
  },
  {
    "marca": "KIA",
    "modelo": "MOHAVE",
    "busquedas": "4"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "MALIBU LIMITED",
    "busquedas": "4"
  },
  {
    "marca": "INFINITI",
    "modelo": "G37",
    "busquedas": "4"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "CROSSFIRE",
    "busquedas": "4"
  },
  {
    "marca": "MINI",
    "modelo": "COOPER CLUBMAN",
    "busquedas": "4"
  },
  {
    "marca": "DODGE",
    "modelo": "RAM 2500 VAN",
    "busquedas": "4"
  },
  {
    "marca": "BMW",
    "modelo": "323CI",
    "busquedas": "4"
  },
  {
    "marca": "DODGE",
    "modelo": "RAM 1500 VAN",
    "busquedas": "4"
  },
  {
    "marca": "LEXUS",
    "modelo": "LS460",
    "busquedas": "4"
  },
  {
    "marca": "INFINITI",
    "modelo": "Q50",
    "busquedas": "3"
  },
  {
    "marca": "SUBARU",
    "modelo": "WRX",
    "busquedas": "3"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GLC300",
    "busquedas": "3"
  },
  {
    "marca": "FORD",
    "modelo": "POLICE INTERCEPTOR UTILITY",
    "busquedas": "3"
  },
  {
    "marca": "MAZDA",
    "modelo": "MX-5",
    "busquedas": "3"
  },
  {
    "marca": "GMC",
    "modelo": "SIERRA 3500 HD",
    "busquedas": "3"
  },
  {
    "marca": "FORD",
    "modelo": "AEROSTAR",
    "busquedas": "3"
  },
  {
    "marca": "DODGE",
    "modelo": "RAM 50",
    "busquedas": "3"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "E550",
    "busquedas": "3"
  },
  {
    "marca": "JEEP",
    "modelo": "WRANGLER JK",
    "busquedas": "3"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO 1500 HD",
    "busquedas": "3"
  },
  {
    "marca": "JMC",
    "modelo": "JX",
    "busquedas": "3"
  },
  {
    "marca": "SATURN",
    "modelo": "OUTLOOK",
    "busquedas": "3"
  },
  {
    "marca": "BMW",
    "modelo": "540I",
    "busquedas": "3"
  },
  {
    "marca": "SUZUKI",
    "modelo": "DZIRE",
    "busquedas": "3"
  },
  {
    "marca": "CHANGAN",
    "modelo": "CM10",
    "busquedas": "3"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "RANGE ROVER EVOQUE",
    "busquedas": "3"
  },
  {
    "marca": "BMW",
    "modelo": "M3",
    "busquedas": "3"
  },
  {
    "marca": "BMW",
    "modelo": "335IS",
    "busquedas": "3"
  },
  {
    "marca": "BMW",
    "modelo": "335I XDRIVE",
    "busquedas": "3"
  },
  {
    "marca": "JEEP",
    "modelo": "CJ7",
    "busquedas": "3"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "AVEO5",
    "busquedas": "3"
  },
  {
    "marca": "BMW",
    "modelo": "135I",
    "busquedas": "3"
  },
  {
    "marca": "BMW",
    "modelo": "550I",
    "busquedas": "3"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "MONTE CARLO",
    "busquedas": "3"
  },
  {
    "marca": "FORD",
    "modelo": "F-250 HD",
    "busquedas": "3"
  },
  {
    "marca": "GMC",
    "modelo": "YUKON XL 1500",
    "busquedas": "3"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SUBURBAN 3500 HD",
    "busquedas": "3"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CORSA",
    "busquedas": "3"
  },
  {
    "marca": "LEXUS",
    "modelo": "RX350L",
    "busquedas": "3"
  },
  {
    "marca": "DODGE",
    "modelo": "SPRINTER 2500",
    "busquedas": "3"
  },
  {
    "marca": "LINCOLN",
    "modelo": "LS",
    "busquedas": "3"
  },
  {
    "marca": "FORD",
    "modelo": "E-250 ECONOLINE",
    "busquedas": "3"
  },
  {
    "marca": "ISUZU",
    "modelo": "I-370",
    "busquedas": "3"
  },
  {
    "marca": "FORD",
    "modelo": "E-150 ECONOLINE CLUB WAGON",
    "busquedas": "3"
  },
  {
    "marca": "SUBARU",
    "modelo": "LOYALE",
    "busquedas": "3"
  },
  {
    "marca": "RENAULT",
    "modelo": "CLIO II",
    "busquedas": "3"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "ML430",
    "busquedas": "3"
  },
  {
    "marca": "ACURA",
    "modelo": "CL",
    "busquedas": "3"
  },
  {
    "marca": "FORD",
    "modelo": "C-MAX",
    "busquedas": "2"
  },
  {
    "marca": "RAM",
    "modelo": "PROMASTER 1500",
    "busquedas": "2"
  },
  {
    "marca": "FORD",
    "modelo": "FIVE HUNDRED",
    "busquedas": "2"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO 2500 HD CLASSIC",
    "busquedas": "2"
  },
  {
    "marca": "SUZUKI",
    "modelo": "VERONA",
    "busquedas": "2"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "STARIA",
    "busquedas": "2"
  },
  {
    "marca": "PORSCHE",
    "modelo": "911",
    "busquedas": "2"
  },
  {
    "marca": "GMC",
    "modelo": "SYCLONE",
    "busquedas": "2"
  },
  {
    "marca": "DATSUN",
    "modelo": "PICKUP",
    "busquedas": "2"
  },
  {
    "marca": "GMC",
    "modelo": "SIERRA 1500 CLASSIC",
    "busquedas": "2"
  },
  {
    "marca": "BMW",
    "modelo": "228I GRAN COUPE",
    "busquedas": "2"
  },
  {
    "marca": "TOYOTA",
    "modelo": "AGYA",
    "busquedas": "2"
  },
  {
    "marca": "PONTIAC",
    "modelo": "GRAND AM",
    "busquedas": "2"
  },
  {
    "marca": "JAGUAR",
    "modelo": "XF",
    "busquedas": "2"
  },
  {
    "marca": "GMC",
    "modelo": "SAVANA 3500",
    "busquedas": "2"
  },
  {
    "marca": "PONTIAC",
    "modelo": "FIREBIRD",
    "busquedas": "2"
  },
  {
    "marca": "PONTIAC",
    "modelo": "AZTEK",
    "busquedas": "2"
  },
  {
    "marca": "HONDA",
    "modelo": "CIVIC DEL SOL",
    "busquedas": "2"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "R20 SUBURBAN",
    "busquedas": "2"
  },
  {
    "marca": "EAGLE",
    "modelo": "TALON",
    "busquedas": "2"
  },
  {
    "marca": "BMW",
    "modelo": "M5",
    "busquedas": "2"
  },
  {
    "marca": "LINCOLN",
    "modelo": "CONTINENTAL",
    "busquedas": "2"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "S430",
    "busquedas": "2"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "S350",
    "busquedas": "2"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "NOVA",
    "busquedas": "2"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "C200",
    "busquedas": "2"
  },
  {
    "marca": "LEXUS",
    "modelo": "RX450H",
    "busquedas": "2"
  },
  {
    "marca": "PEUGEOT",
    "modelo": "306",
    "busquedas": "2"
  },
  {
    "marca": "PEUGEOT",
    "modelo": "206",
    "busquedas": "2"
  },
  {
    "marca": "JEEP",
    "modelo": "COMANCHE",
    "busquedas": "2"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "LUV",
    "busquedas": "2"
  },
  {
    "marca": "NISSAN",
    "modelo": "TSURU",
    "busquedas": "2"
  },
  {
    "marca": "SATURN",
    "modelo": "AURA",
    "busquedas": "2"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "E55 AMG",
    "busquedas": "2"
  },
  {
    "marca": "NISSAN",
    "modelo": "PULSAR NX",
    "busquedas": "2"
  },
  {
    "marca": "SATURN",
    "modelo": "LS",
    "busquedas": "2"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "RANGE ROVER VELAR",
    "busquedas": "2"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "GOL",
    "busquedas": "2"
  },
  {
    "marca": "NISSAN",
    "modelo": "210",
    "busquedas": "2"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "PASSAT CC",
    "busquedas": "2"
  },
  {
    "marca": "BMW",
    "modelo": "750I",
    "busquedas": "2"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "CORDIA",
    "busquedas": "2"
  },
  {
    "marca": "SCION",
    "modelo": "IA",
    "busquedas": "2"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GL350",
    "busquedas": "2"
  },
  {
    "marca": "KIA",
    "modelo": "NIRO",
    "busquedas": "2"
  },
  {
    "marca": "MERCURY",
    "modelo": "TOPAZ",
    "busquedas": "2"
  },
  {
    "marca": "KIA",
    "modelo": "K3",
    "busquedas": "2"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "TRANSPORTER",
    "busquedas": "2"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "AZERA",
    "busquedas": "2"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "G20",
    "busquedas": "2"
  },
  {
    "marca": "CHERY",
    "modelo": "TIGGO 4 PRO",
    "busquedas": "2"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "KONA",
    "busquedas": "2"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "TRAVERSE LIMITED",
    "busquedas": "2"
  },
  {
    "marca": "SATURN",
    "modelo": "SC1",
    "busquedas": "2"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "SLK320",
    "busquedas": "2"
  },
  {
    "marca": "VOLVO",
    "modelo": "V70",
    "busquedas": "2"
  },
  {
    "marca": "VOLVO",
    "modelo": "XC40",
    "busquedas": "2"
  },
  {
    "marca": "BMW",
    "modelo": "530XI",
    "busquedas": "2"
  },
  {
    "marca": "SATURN",
    "modelo": "SKY",
    "busquedas": "2"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "SL550",
    "busquedas": "2"
  },
  {
    "marca": "JEEP",
    "modelo": "WAGONEER",
    "busquedas": "2"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SPARK EV",
    "busquedas": "2"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "SANTA FE XL",
    "busquedas": "2"
  },
  {
    "marca": "MAZDA",
    "modelo": "E2200",
    "busquedas": "2"
  },
  {
    "marca": "SATURN",
    "modelo": "SW2",
    "busquedas": "1"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "G63 AMG",
    "busquedas": "1"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "CLK550",
    "busquedas": "1"
  },
  {
    "marca": "DODGE",
    "modelo": "RAMCHARGER",
    "busquedas": "1"
  },
  {
    "marca": "SUZUKI",
    "modelo": "LIANA",
    "busquedas": "1"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GLS350D",
    "busquedas": "1"
  },
  {
    "marca": "FORD",
    "modelo": "ASPIRE",
    "busquedas": "1"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "MATIZ",
    "busquedas": "1"
  },
  {
    "marca": "PEUGEOT",
    "modelo": "3008",
    "busquedas": "1"
  },
  {
    "marca": "AUDI",
    "modelo": "TT QUATTRO",
    "busquedas": "1"
  },
  {
    "marca": "FORD",
    "modelo": "FIESTA IKON",
    "busquedas": "1"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "AVANTE",
    "busquedas": "1"
  },
  {
    "marca": "MAXUS",
    "modelo": "D90",
    "busquedas": "1"
  },
  {
    "marca": "DODGE",
    "modelo": "SPRINTER 3500",
    "busquedas": "1"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CORSICA",
    "busquedas": "1"
  },
  {
    "marca": "ZNA",
    "modelo": "RICH 6",
    "busquedas": "1"
  },
  {
    "marca": "MAZDA",
    "modelo": "CX-70",
    "busquedas": "1"
  },
  {
    "marca": "BMW",
    "modelo": "228I",
    "busquedas": "1"
  },
  {
    "marca": "BMW",
    "modelo": "325IS",
    "busquedas": "1"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "VIRTUS",
    "busquedas": "1"
  },
  {
    "marca": "MAZDA",
    "modelo": "NAVAJO",
    "busquedas": "1"
  },
  {
    "marca": "LEXUS",
    "modelo": "SC430",
    "busquedas": "1"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "CLK350",
    "busquedas": "1"
  },
  {
    "marca": "MERCURY",
    "modelo": "CAPRI",
    "busquedas": "1"
  },
  {
    "marca": "TOYOTA",
    "modelo": "PRIUS C",
    "busquedas": "1"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "CLK320",
    "busquedas": "1"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "EXPRESS PASAJEROS",
    "busquedas": "1"
  },
  {
    "marca": "AUDI",
    "modelo": "S5",
    "busquedas": "1"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "S500",
    "busquedas": "1"
  },
  {
    "marca": "KIA",
    "modelo": "AMANTI",
    "busquedas": "1"
  },
  {
    "marca": "JAC",
    "modelo": "JS2",
    "busquedas": "1"
  },
  {
    "marca": "RENAULT",
    "modelo": "SCENIC",
    "busquedas": "1"
  },
  {
    "marca": "DODGE",
    "modelo": "B250",
    "busquedas": "1"
  },
  {
    "marca": "DAEWOO",
    "modelo": "MATIZ",
    "busquedas": "1"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SONORA",
    "busquedas": "1"
  },
  {
    "marca": "ACURA",
    "modelo": "ZDX",
    "busquedas": "1"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "SPRINTER 2500",
    "busquedas": "1"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "SPRINTER",
    "busquedas": "1"
  },
  {
    "marca": "HONDA",
    "modelo": "CRX",
    "busquedas": "1"
  },
  {
    "marca": "BMW",
    "modelo": "740IL",
    "busquedas": "1"
  },
  {
    "marca": "BMW",
    "modelo": "645CI",
    "busquedas": "1"
  },
  {
    "marca": "JEEP",
    "modelo": "GRAND CHEROKEE L",
    "busquedas": "1"
  },
  {
    "marca": "GMC",
    "modelo": "K1500",
    "busquedas": "1"
  },
  {
    "marca": "RAM",
    "modelo": "DAKOTA",
    "busquedas": "1"
  },
  {
    "marca": "HONDA",
    "modelo": "CLARITY",
    "busquedas": "1"
  },
  {
    "marca": "BMW",
    "modelo": "430I",
    "busquedas": "1"
  },
  {
    "marca": "AUDI",
    "modelo": "A7",
    "busquedas": "1"
  },
  {
    "marca": "JAC",
    "modelo": "T8 PRO",
    "busquedas": "1"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "500SEL",
    "busquedas": "1"
  },
  {
    "marca": "VOLVO",
    "modelo": "V40 CROSS COUNTRY",
    "busquedas": "1"
  },
  {
    "marca": "VOLVO",
    "modelo": "V50",
    "busquedas": "1"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "S550",
    "busquedas": "1"
  },
  {
    "marca": "GMC",
    "modelo": "SAVANA 1500",
    "busquedas": "1"
  },
  {
    "marca": "MAZDA",
    "modelo": "MILLENIA",
    "busquedas": "1"
  },
  {
    "marca": "JMC",
    "modelo": "PICK UP",
    "busquedas": "1"
  },
  {
    "marca": "BMW",
    "modelo": "228I XDRIVE",
    "busquedas": "1"
  },
  {
    "marca": "SUZUKI",
    "modelo": "KIZASHI",
    "busquedas": "1"
  },
  {
    "marca": "RAM",
    "modelo": "PROMASTER CITY",
    "busquedas": "1"
  },
  {
    "marca": "SUZUKI",
    "modelo": "EECO CARGO",
    "busquedas": "1"
  },
  {
    "marca": "ASTON MARTIN",
    "modelo": "DBS",
    "busquedas": "1"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "EOS",
    "busquedas": "1"
  },
  {
    "marca": "DODGE",
    "modelo": "D250",
    "busquedas": "1"
  },
  {
    "marca": "NISSAN",
    "modelo": "NV3500",
    "busquedas": "1"
  },
  {
    "marca": "GMC",
    "modelo": "YUKON XL 2500",
    "busquedas": "1"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "CRAFTER",
    "busquedas": "1"
  },
  {
    "marca": "LAMBORGHINI",
    "modelo": "MURCIELAGO",
    "busquedas": "1"
  },
  {
    "marca": "BMW",
    "modelo": "318TI",
    "busquedas": "1"
  },
  {
    "marca": "BMW",
    "modelo": "535I XDRIVE",
    "busquedas": "1"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "NIVUS",
    "busquedas": "1"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "XPANDER CROSS",
    "busquedas": "1"
  },
  {
    "marca": "KIA",
    "modelo": "TOWNER",
    "busquedas": "1"
  },
  {
    "marca": "INFINITI",
    "modelo": "Q60",
    "busquedas": "1"
  },
  {
    "marca": "CADILLAC",
    "modelo": "DTS",
    "busquedas": "1"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "DAMAS/LABO",
    "busquedas": "1"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "PRECIS",
    "busquedas": "1"
  },
  {
    "marca": "BMW",
    "modelo": "750LI",
    "busquedas": "1"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "C2500 SUBURBAN",
    "busquedas": "1"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "C2500",
    "busquedas": "1"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "GRAND VOYAGER",
    "busquedas": "1"
  },
  {
    "marca": "GMC",
    "modelo": "SIERRA 3500",
    "busquedas": "1"
  },
  {
    "marca": "TESLA",
    "modelo": "3",
    "busquedas": "1"
  },
  {
    "marca": "FIAT",
    "modelo": "500X",
    "busquedas": "1"
  },
  {
    "marca": "HUMMER",
    "modelo": "H1",
    "busquedas": "1"
  },
  {
    "marca": "FIAT",
    "modelo": "124 SPIDER",
    "busquedas": "1"
  },
  {
    "marca": "FORD",
    "modelo": "THUNDERBIRD",
    "busquedas": "1"
  }
];

export default preloadedTopVehicles;
